var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"request",class:{ lightRequest: _vm.isDarkMode, darkRequest: !_vm.isDarkMode }},[_vm._v(" Don't have a WOLF HQ account? "),_c('router-link',{attrs:{"to":"/request"}},[_vm._v("Request an account")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }